import React, { useState } from "react";
import PropTypes from "prop-types";
import { makeStyles,withStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import InputLabel from '@material-ui/core/InputLabel';
import TextField from "@material-ui/core/TextField";
import Actionadd from "./actionAddpopup";
import _ from "lodash";
import moment from "moment";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Button from "@material-ui/core/Button";
import DarkButton from "./../../Global/DarkButton";
import GlobalApi from "./../../Global";
import swal from "@sweetalert/with-react";
import refresh_token from "./../../Global/refresh_token";
import { useHistory } from "react-router-dom";
import { saveAs } from "file-saver";
import Colors from "./../../Global/colors";
import Checkbox from "@material-ui/core/Checkbox";
import { useSelector, useDispatch } from "react-redux";
import Paper from "@material-ui/core/Paper";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import due_date from "../../Assets/due_date.png";
import DeleteIcon from "@material-ui/icons/Delete";
import {useTranslation} from "react-i18next";
let textInput = React.createRef();


const capitalize = (str) => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

const AntTabs = withStyles({
  root: {
    backgroundColor: "#ffffff",
    color: "#222",
  },
  indicator: {
    backgroundColor:'#1a73e8'
    // display:'none'
  },
})(Tabs);


function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    marginLeft: 0,
    backgroundColor: theme.palette.background.paper,
  },
}));

export default function InspectionModalTabs({ data, InspectionShares, users, currentEditRow }) {
  let {t} = useTranslation();
  let company = useSelector((state) => state.companyReducer.company);
  console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>",currentEditRow , data)
  const [state, setState] = useState({
    Schedule: [],

    filter_arr: null,
  });
  let history = useHistory();
  let [actionData, setActionData] = React.useState([]);
  const [selectedUser, setSelectedUser] = React.useState(null);
  const [shares, setShares] = React.useState([]);
  const [currentUser, setCurrentUser] = React.useState({});
  const [newData, setNewData] = React.useState({});

  const classes = useStyles();
  const [value, setValue] = React.useState(0);
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const ModalOpen = () => {
    setIsModalOpen(true);
  };


  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  
  const handleDownload = async (inspection_id) => {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    let params = {
      inspection_id,
      user_id: data.user_id,
      url: GlobalApi.replace("api", ""),
    };
    let package_inquiry = {
      user_id: data.user_id,
      organization_id: data.organization_id,
    };
    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");
    console.log(query);
  
    let query1 = Object.keys(package_inquiry)
      .map(
        (k) =>
          encodeURIComponent(k) + "=" + encodeURIComponent(package_inquiry[k])
      )
      .join("&");

    let req = await fetch(GlobalApi + "/Package/get_user_license_details?" + query1, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    });
  
    let reqJson = await req.json();
  
    if (reqJson.package.pdf_request_status === "Request is Valid") {
      console.log("CREATE PDF NEW_______________________________", currentEditRow);
      if (currentEditRow?.isCompleted == true || (currentEditRow?.pdf_url !== null && currentEditRow?.pdf_url !== undefined)) {
        let pdfData = await fetch(
          GlobalApi + "/Inspection/create-pdf?" + query,
          {
            method: "GET",
            headers: {
              Authorization: "Bearer " + token,
              "Content-Type": "application/json",
            },
          }
        );
        let pdfDataJson = await pdfData.json();
        console.log("pdfData", pdfDataJson.pdf_url);
        window.open(pdfDataJson.pdf_url, '_blank');
      } else {
        // await saveAs(GlobalApi + "/Inspection/create-pdf?" + query);
        let pdfData = await fetch(
          GlobalApi + "/Inspection/create-pdf?" + query,
          {
            method: "GET",
            headers: {
              Authorization: "Bearer " + token,
              "Content-Type": "application/json",
            },
          }
        );

        const blob = await pdfData.blob();
        // setwaitForResponseWithOverlay( false );

        // const fileURL = URL.createObjectURL( blob );
        
  
        await saveAs(blob);
      }


     
    } else {
      swal(t("Warning"), reqJson.package.pdf_request_status, "warning");
    }
  };
  
  const getdata = (e) => {
    console.log(e);
    let localstorage = localStorage.getItem("UserData");
    let lol = JSON.parse(localstorage);
    let token = lol.token;
    // console.log(selectedUser);
    if (e.user_id.id) {
      fetch(GlobalApi + "/Action/create_action", {
        method: "post",
        headers: new Headers({
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        }),
        body: JSON.stringify({
          ...e,
          inspection_id: data.id,
          user_id: e.user_id.id,
          created_by: lol.user_id,
          company_id: company.id,
          identifier: "Inspection",
          title: `${newData?.schedule_title} / ${moment(newData?.createdAt).format(
            "MMMM DD, YYYY"
          )}`,
        }),
      })
        .then((response) => response.json())
        .then(async (res) => {
          if (res.status === "Success") {
            setActionData([...actionData, res.data]);
          }else if(res.status === "Error"){
            swal(t("Error"),res.err,"error");
          }
          

          swal(t("Error"),res.err,"error");
          console.log(res);
        });
    } else {
      swal(t("Warning"), t("Please Select an Assignee First"), "warning");
    }
  };

  
  // let score_nag = data?.InspectionAnswers?.filter((v) => {
  //   // console.log(answers[v.id]?.value, answers[v.id])
  //   if (
  //     v.parent_id === null &&
  //     (v.value === "" ||
  //       v.value === "[]" ||
  //       v.value === undefined ||
  //       v.value === null)
  //   ) {
  //     console.log("o");
  //     return v;
  //   }
  // });

  // let score = (
  //   ((data?.InspectionAnswers?.filter((v) => v.parent_id === null).length -
  //     score_nag.length) /
  //     data?.InspectionAnswers?.filter((v) => v.parent_id === null).length) *
  //   100
  // ).toFixed();

  const fetchShares = () => {
    let localstorage = localStorage.getItem("UserData");
    var data_ = JSON.parse(localstorage);
    let token = data_?.token;
    let params = {
      inspection_id: data.id,
    };

    // alert(JSON.stringify(params))

    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    fetch(GlobalApi + "/InspectionShare/get_all_inspection_shares?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        console.log(response);
        if (response.status == "Success") {
          setShares(response.data);
          console.log("SHARES", response.data);
        } else if (
          response.error === "jwt expired" ||
          response.error === "invalid token" ||
          response.error === "invalid signature" ||
          response.error == "Unexpected token"
        ) {
          let status = await refresh_token();
          console.log(status);
          if (status) {
            console.log("opopopop");
            fetchShares();
          }
        }
      })
      .catch((error) => console.log(error.message));
  };

  async function handleDelete(inspection_share_id) {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    await fetch(GlobalApi + "/InspectionShare/delete_inspection_share", {
      method: "post",
      headers: new Headers({
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      }),
      body: JSON.stringify({
        inspection_share_id,
      }),
    });

    fetchShares();
  }

  async function handleEditorToggle(isEditor, inspection_share_id) {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    await fetch(GlobalApi + "/InspectionShare/edit_inspection_share", {
      method: "post",
      headers: new Headers({
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      }),
      body: JSON.stringify({
        inspection_share_id,
        isEditor,
      }),
    });

    fetchShares();
  }

  console.log("newData",newData);

  React.useEffect(() => {
    fetchShares();
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);

    setCurrentUser(data);
    fetchMoreOptionsData()
  }, []);

  const fetchMoreOptionsData = () => {
    let localstorage = localStorage.getItem("UserData");
    var data_ = JSON.parse(localstorage);
    let token = data_?.token;
    let params = {
      user_id: data_.user_id,
      inspection_id: data.id,
    };

    console.log("TTTTTTTTTTTTTTTTTTTTTTT",token)

    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    fetch(GlobalApi + "/Inspection/get_inspection_more_options_data?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        console.log(response,"response");
        if (response.msg == "success") {
          setNewData(response.data);
          setActionData(response.data.Actions)
          console.log("NEW DATA ________________________________", response.data);
        } else if (
          response.error === "jwt expired" ||
          response.error === "invalid token" ||
          response.error === "invalid signature" ||
          response.error == "Unexpected token"
        ) {
          let status = await refresh_token();
          console.log(status);
          if (status) {
            console.log("opopopop");
            fetchMoreOptionsData();
          }
        }
      })
      .catch((error) => console.log(error.message));
  };

  const handleAddresponseClick = (e) => {
    let localstorage = localStorage.getItem("UserData");
    var lol = JSON.parse(localstorage);
    let token = lol.token;
    console.log(selectedUser);
    if (selectedUser !== null) {
      if (shares.filter((v) => v.user_id == selectedUser).length !== 0) {
        swal(t("Warning"), t("User already exists"), "warning");
      } else {
        fetch(GlobalApi + "/InspectionShare/create_inspection_share", {
          method: "post",
          headers: new Headers({
            Authorization: "Bearer " + token,
            "Content-Type": "application/json",
          }),
          body: JSON.stringify({
            inspection_id: data.id,
            user_id: selectedUser,
            created_by: lol.user_id,
            role: "Viewer",
            isEditor: false,
            isOwner: false,
          }),
        })
          .then((response) => response.json())
          .then(async (res) => {
            setSelectedUser(null);
            fetchShares();
          });
      }
    } else {
      swal(t("Warning"), t("User is Required"), "warning");
    }
  };

  const list = (
    <div className="">
      {/* <div className="col s12">
    <span>Add People</span>
  </div> */}
      <div className="col s12">
        <div className="row" style={{overflow:'hidden'}}>
          <Grid container alignItems="center" spacing={1}>
            <Grid item xs={12} md={9}>
              {/* <Autocomplete
                id="country-select-demoss"
                fullWidth
                options={users}
                autoHighlight
                getOptionLabel={(option) =>
                  `${option.first_name} ${option.last_name}`
                }
                renderOption={(option) => (
                  <React.Fragment>
                    {option.first_name} {option.last_name}
                  </React.Fragment>
                )}
                value={selectedUser}
                onChange={(e, v) => setSelectedUser(v)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    size="small"
                    label="Assignee"
                    variant="outlined"
                    fullWidth
                    inputProps={
                      { ...params.inputProps, autoComplete: "new-password" } // value={selectedUser}
                    }
                  />
                )}
              /> */}
              
<FormControl variant="outlined" size="small" style={{ width: "100%", height: "40px" }}>
                <InputLabel id="demo-simple-select-outlined-label">
                {t("Assignee")}
                </InputLabel>
                <Select size="small" style={{ backgroundColor: "#f7f9fb" }} labelId="demo-simple-select-outlined-label" id="demo-simple-select-outlined" value={selectedUser}          onChange={(e) => {
                setSelectedUser(e.target.value);
              }} label={t("Assignee")}>
                  {users.map((item, index) => {
                    return <MenuItem value={item.id}>{item.first_name + " " + item.last_name}</MenuItem>;
                  })}
                </Select>
              </FormControl>

            </Grid>
            <Grid item xs={12} md={3}>
              <Button
                variant="contained"
                type="submit"
                className="addBtn"
                component="span"
                disabled={currentUser.user_id !== newData?.created_by}
                onClick={(e) => handleAddresponseClick(e)}
              >
                {t("Create")}
              </Button>
            </Grid>
          </Grid>

          {/* <div className="col s8">
            <Autocomplete id="country-select-demoss" fullWidth options={users} autoHighlight getOptionLabel={(option) => `${option.first_name} ${option.last_name}`} renderOption={(option) => <React.Fragment>
                  {option.first_name} {option.last_name}
                </React.Fragment>} value={selectedUser} onChange={(e, v) => setSelectedUser(v)} renderInput={(params) => <TextField {...params} size="small" label="Assignee" variant="outlined" fullWidth inputProps={{ ...params.inputProps, autoComplete: "new-password" } // value={selectedUser}
                  } />} />
          </div>
          <div className="col s4">
            <Button variant="contained" type="submit" className="addBtn" component="span" disabled={currentUser.user_id !== data.created_by} onClick={(e) => handleAddresponseClick(e)}>
              {"Create"}
            </Button>
          </div> */}
        </div>

      </div>
      <div className="col s12">
        <p className="label2" style={{ color: Colors.globalColor8 }}>
          {t("Current Shares")}
        </p>
      </div>
      <div className="col s12" style={{ height: "200px" }}>
        <div className="col s12 ">
          <div className="row custom-row" style={{overflow:'hidden'}}>
            {shares.map((share, index) => {
              return (
                <Paper
                  variant={"outlined"}
                  style={{
                    marginTop: 10,
                    padding: 10,
                    backgroundColor: Colors.globalColor9,
                  }}
                >
                  <Typography variant="p" style={{ fontWeight: "bolder" }}>
                    {share?.User?.first_name} {share?.User?.last_name}
                  </Typography>
                  <Grid container alignItems="center" spacing={2}>
                    <Grid item xs={6}>
                      <Typography variant="p">
                        {share?.isOwner == true ||
                        share?.user_id === newData?.created_by
                          ? <>{t("Owner")}</>
                          : <>{t("Viewer")}</>}
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Grid container align="right">
                        <Grid item xs={10}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={share?.isEditor}
                                onChange={() =>
                                  handleEditorToggle(!share?.isEditor, share.id)
                                }
                                disabled={
                                  newData?.created_by == currentUser.user_id
                                    ? false
                                    : true ||
                                      shares.filter(
                                        (v) => v.user_id === currentUser.user_id
                                      )[0]?.isOwner == false
                                    ? true
                                    : false
                                }
                              />
                            }
                            label={t("Is Editor")}
                          />
                        </Grid>
                        <Grid item xs={2}>
                          <IconButton
                            aria-label="delete"
                            className={classes.margin}
                            onClick={() => handleDelete(share.id)}
                            disabled={
                              newData?.created_by == currentUser.user_id
                                ? false
                                : true ||
                                  shares.filter(
                                    (v) => v.user_id === currentUser.user_id
                                  )[0]?.isOwner == false
                                ? true
                                : false
                            }
                          >
                            <DeleteIcon fontSize="small" />
                          </IconButton>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Paper>
              );
            })}
          </div>
          <br/>
          <br/>
        </div>
      </div>
    </div>
  );

  const list1 = actionData?.map((value, index) => {
    return (
      <Grid item xs={12} justifyContent="center" alignItems="flex-end" style={{width:'100%'}}>
                
              <div className="hover shadow" style={{ display: "flex", justifyContent: "space-between", flexDirection: "column", border: "1px solid #dadada", padding: "10px", margin: "5px 0", flexDirection: "column", justifyContent: "space-between", alignItems: "center", width: "100%", textAlign: "left",  borderRadius: "5px", backgroundColor: "white" }}>
                <div style={{ width: "100%" }}>
                  {value.priority && <>
                      {value.priority == "High Priority" && <div style={{ backgroundColor: "#B00020", display: "inline-block", textAlign: "left", padding: "2px 10px", borderRadius: "20px" }}>
                          <p
                            style={{
                              margin: "0px",
                              color: "white",
                              fontSize: "10px",
                              fontWeight: "bold",
                              textAlign: "left",
                            }}
                          >
                            {value.priority.split(" ")[0]}
                          </p>
                        </div>}

                      {value.priority == "Medium Priority" && <div style={{ backgroundColor: "#299617", display: "inline-block", textAlign: "left", padding: "2px 10px", borderRadius: "20px" }}>
                          <p
                            style={{
                              margin: "0px",
                              color: "white",
                              fontSize: "10px",
                              fontWeight: "bold",
                              textAlign: "left",
                            }}
                          >
                            {value.priority.split(" ")[0]}
                          </p>
                        </div>}

                      {value.priority == "Low Priority" && <div style={{ backgroundColor: "#EEB609", display: "inline-block", textAlign: "left", padding: "2px 10px", borderRadius: "20px" }}>
                          <p
                            style={{
                              margin: "0px",
                              color: "white",
                              fontSize: "10px",
                              fontWeight: "bold",
                              textAlign: "left",
                            }}
                          >
                            {value.priority.split(" ")[0]}
                          </p>
                        </div>}
                    </>}
                    <p style={{ color: Colors.globalColor8, fontWeight: "bold", fontSize: "16px", textAlign: "left", marginBottom:"0px" }}>
                        {capitalize(value.title)}
                      </p>
                </div>

                <div style={{ width: "100%" }}>
                  {value.due && <div>
                      <div style={{ display: "flex", flexDirection: "row" }}>
                        <img src={due_date} width={15} height={15} />
                        &nbsp;
                        <p className="label2" style={{ marginBottom: 5, fontSize: 12, marginTop: 0, color: "grey", textTransform: "capitalized" }}>
                          {moment(value.due).format("MM-DD-YYYY")}
                        </p>
                      </div>
                    </div>}
                    <div style={{ display: "flex", flexDirection: "row" }}>
                    <p className="label2" style={{ marginBottom: 5, fontSize: 12, marginTop: 0, color: "grey", textTransform: "capitalized" }}>
                          Active Since :  
                        </p>
                        &nbsp;
                        <p className="label2" style={{ marginBottom: 5, fontSize: 12, marginTop: 0, color: "grey", textTransform: "capitalized" }}>
                        {moment(value.updatedAt).fromNow()}
                        </p>
                        </div>
                        <div style={{ display: "flex", flexDirection: "row" }}>
                    <p className="label2" style={{ marginBottom: 5, fontSize: 12, marginTop: 0, color: "grey", textTransform: "capitalized" }}>
                          Status :  
                        </p>
                        &nbsp;
                        <p className="label2" style={{ marginBottom: 5, fontSize: 12, marginTop: 0, color: "grey", textTransform: "capitalized" }}>
                        {value.status ? value.status : "To Do"}
                        </p>
                        </div>
                </div>
              </div>
            </Grid>
      // <React.Fragment>
      //   <div className="row">
      //     <div className="col s6 left-align">{value.title}</div>
      //     <div className="col s6 right-align">
      //       {value.due ? moment(value.due).format("MMMM DD, YYYY") : ""}
      //     </div>
      //     <div className="col s6 left-align">{value.assignee}</div>
      //     <div className="col s6 right-align">
      //       <span>&nbsp;</span>
      //     </div>
      //     <div className="col s6 left-align">{value.priority}</div>
      //     <div className="col s6 right-align">
      //       {value.status ? (
      //         <div className="chip teal lighten-5 ">{value.status}</div>
      //       ) : (
      //         ""
      //       )}
      //     </div>
      //   </div>
      //   <hr />
      // </React.Fragment>
    );
  });
  console.log(users);

  console.log(data);
  return <div className={classes.root}>
     <AntTabs value={value} onChange={handleChange} className="MoreOptionsTab" style={{borderBottom:'1px solid #dadada'}}>
        {/* <Tabs value={value} onChange={handleChange} aria-label="simple tabs example" indicatorColor="primary"> */}
          <Tab  style={{ marginTop: "5px",borderTopLeftRadius:'10px',borderTopRightRadius:'10px', textTransform: "uppercase", fontSize: 12, fontWeight: "bold", backgroundColor: value == 0 ? Colors.globalColor9 : "transparent", color: value == 0 ? "#1a73e8" : "black" }}   label={t("Details")} {...a11yProps(0)} />
          <Tab  style={{ marginTop: "5px",borderTopLeftRadius:'10px',borderTopRightRadius:'10px', textTransform: "uppercase", fontSize: 12, fontWeight: "bold", backgroundColor: value == 1 ? Colors.globalColor9 : "transparent", color: value == 1 ? "#1a73e8" : "black" }}   label={t("Sharing")} {...a11yProps(1)} />
          <Tab  style={{ marginTop: "5px",borderTopLeftRadius:'10px',borderTopRightRadius:'10px', textTransform: "uppercase", fontSize: 12, fontWeight: "bold", backgroundColor: value == 2 ? Colors.globalColor9 : "transparent", color: value == 2 ? "#1a73e8" : "black" }}  label={t("Action")} {...a11yProps(2)} />
        </AntTabs>
    
      <TabPanel value={value} index={0}>
        <div className="">
          <table class="details-table" style={{ maxWidth: "450px" }}>
            <tbody>
              <tr>
                <td className="custom-spacing">{t("Template")}</td>
                <td className="table-truncate">
                  <b>{newData?.template_title}</b>
                </td>
              </tr>
              <tr>
                <td className="custom-spacing">{t("Status")}</td>
                <td>
                  <b>{currentEditRow?.isCompleted === true ? "completed" : "Incomplete"}</b>
                  {/* {(
                    ((data?.InspectionAnswers?.length - score_nag.length) /
                      data?.InspectionAnswers?.length) *
                    100
                  ).toFixed() !== "100" ? (
                    <b style={{ color: "red" }}> Incomplete</b>
                  ) : (
                    <b style={{ color: "green" }}>Completed</b>
                  )} */}
                </td>
              </tr>
              <tr>
                <td className="custom-spacing">{t("Score")}</td>
                <td>
                  <b>{currentEditRow?.score ? currentEditRow.score : 0}%</b>
                </td>
              </tr>
              {/* <tr>
                <td className="custom-spacing">Items Completed</td>
                <td>
                  <div>
                    <b>
                      {data?.InspectionAnswers?.length - score_nag.length} / {data?.InspectionAnswers?.length}
                    </b>
                  </div>
                </td>
              </tr> */}
              <tr>
                <td className="custom-spacing">{t("Company")}</td>
                <td>
                  <div>  <b>{newData?.Company?.company_name && newData?.Company?.company_name}</b></div>
                </td>
              </tr>
              <tr>
                <td className="custom-spacing">{t("Owner")}</td>
                <td>
                  <div>
                    <b>
                      {newData?.User?.first_name} {newData?.User?.last_name}
                    </b>
                  </div>
                </td>
              </tr>
              {/* <tr>
                <td className="custom-spacing">Author</td>
                <td>
                  <div>
                    <b>
                      {data.TemplateInspection?.User?.first_name}{" "}
                      {data.TemplateInspection?.User?.last_name}
                    </b>
                  </div>
                </td>
              </tr> */}
              {/* <tr>
                <td className="custom-spacing">Last modified by</td>
                <td>
                  <div>
                    <b>Khurram Naushad Khan</b>
                  </div>
                </td>
              </tr> */}
            </tbody>
          </table>
        </div>
        <Grid container spacing={3} direction="row">
          <Grid item xs={6}>
          

            <Button variant="contained" type="submit" className="addBtn" component="span" style={{ margin: 3, backgroundColor: Colors.globalColor8 }} fullWidth onClick={() => history.push("/inspection-print/" + data.id + "/" +  currentEditRow?.isCompleted+ "/false")}>
              {t("View Report")}
            </Button>
          </Grid>
          <Grid xs={6} item>
            {/* <DarkButton
              style={{ margin: 3,backgroundColor:Colors.globalColor8 }}
              fullWidth
              onClick={() => handleDownload(data.id)}
            >
              Export Report
            </DarkButton> */}

            <Button variant="contained" type="submit" className="addBtn" component="span" style={{ margin: 3, backgroundColor: Colors.globalColor8 }} fullWidth onClick={() => handleDownload(data.id)}>
              {t("Export Report")}
            </Button>
          </Grid>
        </Grid>
      </TabPanel>
      <TabPanel value={value} index={1}>
        {list}
      </TabPanel>
      <TabPanel value={value} index={2}>
        <div className="col s12" />
        {actionData?.length !== 0 ? <div className="col s8">
          <div style={{diaplay:'flex', overflowY:'auto' , maxHeight:'300px'}}>
            {list1}
            </div>
            <div className="center-align">
              {/* <DarkButton
                fullWidth
                onClick={() => ModalOpen()}
                style={{ margin: 3, backgroundColor: Colors.globalColor8 }}
              >
                Add Action
              </DarkButton> */}

              <Button variant="contained" type="submit" className="addBtn" component="span" fullWidth onClick={() => ModalOpen()}>
                {t("Add Action")}
              </Button>
            </div>
          </div> : <div className="row center-align">
            <div className="container">
              <img src="./images/noaction.svg" style={{ width: "50%" }} alt="" />
              <br />
              <div className="center-align">{t("No Action found")}</div>
              <div className="center-align">
                {t("Click Add Action to add an action to this inspection")}.
              </div>
            </div>

            <hr />
            {/* <DarkButton onClick={() => ModalOpen()} // class="btn waves-effect waves-light"
              style={{ backgroundColor: Colors.globalColor8 }}>
              Add Action
            </DarkButton> */}

            <Button variant="contained" type="submit" className="addBtn" component="span" fullWidth onClick={() => ModalOpen()}>
                {t("Add Action")}
              </Button>
          </div>}
      </TabPanel>
      {isModalOpen && <Actionadd newdata={(e) => getdata(e, value)} onClose={() => setIsModalOpen(false)} data={data} users={users} />}
    </div>;
}
